import React from "react";
import info from "../Info";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer
      className="absolute bottom-0 left-0 w-full border-t backdrop-blur-sm z-20"
      style={{
        borderColor: "var(--border-color)",
        background: "var(--bg-primary)",
      }}
    >
      <div className="px-6 lg:px-10 py-3 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-2 text-xs">
        <p style={{ color: "var(--text-secondary)" }}>
          © {year} {info.fname} {info.lname}. Built with care and caffeine.
        </p>

        <div className="flex flex-wrap items-center gap-3">
          <a
            href={`mailto:${info.email}`}
            className="hover:opacity-70 transition-opacity"
            style={{ color: "var(--accent)" }}
          >
            Email
          </a>
          <a
            href={`https://${info.linkedin}`}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:opacity-70 transition-opacity"
            style={{ color: "var(--accent)" }}
          >
            LinkedIn
          </a>
          <a
            href={`https://${info.github}`}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:opacity-70 transition-opacity"
            style={{ color: "var(--accent)" }}
          >
            GitHub
          </a>
          <a
            href={`https://${info.website}`}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:opacity-70 transition-opacity"
            style={{ color: "var(--accent)" }}
          >
            Website
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
